import { render, staticRenderFns } from "./audio-video.vue?vue&type=template&id=116ea8fe&"
import script from "./audio-video.vue?vue&type=script&lang=js&"
export * from "./audio-video.vue?vue&type=script&lang=js&"
import style0 from "./audio-video.vue?vue&type=style&index=0&id=116ea8fe&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports